import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import {
  readDeepLinkParams,
  writePendingDeepLink,
} from '@/modules/shared/deeplinks';

/**
 * Catches a deep link that arrives on the login/signup page.
 *
 * The auth middleware forwards an email CTA's query string here, but login
 * navigates to `/orth` on its own and drops it, so the link is stashed for
 * `useHandleDeepLink` to pick up once the user is in.
 */
export const useDetectLinkRedirect = () => {
  const searchParams = useSearchParams();
  const redirect = searchParams.get('redirect');
  const notificationId = searchParams.get('notificationId');
  const isFromInsightPage = searchParams.get('isFromInsightPage');

  useEffect(() => {
    // If middleware provided an explicit redirect target, keep URL intact.
    if (redirect) return;

    const deepLink = readDeepLinkParams(searchParams);
    if (deepLink) writePendingDeepLink(deepLink);

    if (notificationId) {
      sessionStorage.setItem(
        'pendingNotificationRedirect',
        JSON.stringify({
          notificationId,
          isFromInsightPage: (isFromInsightPage ?? '').toLowerCase() === 'true',
        })
      );
    }
  }, [redirect, notificationId, isFromInsightPage, searchParams]);
};
